import { getQcTasksQcTasksGet, GetQcTasksQcTasksGetData } from '@common/config/api/client'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

export const usePaginatedTasks = (queryKey: string[], paginationParams: GetQcTasksQcTasksGetData['query']) => {
  return useQuery({
    queryKey: [
      ...queryKey,
      paginationParams.search,
      paginationParams.limit,
      paginationParams.next_cursor,
      paginationParams.previous_cursor,
      paginationParams.order_by_field,
      paginationParams.asc_order,
    ],
    queryFn: () =>
      getQcTasksQcTasksGet({
        query: paginationParams,
      }),
    placeholderData: keepPreviousData,
  })
}
